import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ValidationError } from '@deltager/organizers/admin/shared/error-handler/validation-error.model';


@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private validationErrorsSubject = new BehaviorSubject<ValidationError[]>([]);
  validationErrors$ = this.validationErrorsSubject.asObservable();

  handleValidationErrors(errors: ValidationError[]) {
    this.validationErrorsSubject.next(errors);
  }

  handleError(error: any) {
    // Handle other types of errors
    console.error('An error occurred:', error);
  }

  clearErrors() {
    this.validationErrorsSubject.next([]);
  }
}
